import { FTs } from "./FTs";
import { ABTests } from "./ABTests";
import { getHoursInterval } from "./tools/getHoursInterval";
import { pickIndexByChance } from "./tools/pickIndexByChance";

export const setupFeatureToggles = env => {
  const featureToggles = Object.entries(FTs).reduce((treatedFeatureToggles, [key, FTByEnv]) => {
    try {
      return {
        ...treatedFeatureToggles,
        [key]: !!(FTByEnv || {})[env || ""],
      };
    } catch (err) {
      console.error(err);
      return treatedFeatureToggles;
    }
  }, {});

  sessionStorage.setItem("featureToggles", JSON.stringify(featureToggles));

  return featureToggles;
};

export const setupABTests = env => {
  const ABTestsCache = JSON.parse(localStorage.getItem("ABTests") || "{}");

  const treatedABTests = Object.entries(ABTests).reduce((treatedABTests, [key, ABTestConfigsBase]) => {
    try {
      const ABTestVariations = ABTestConfigsBase?.variations;
      const ABTestConfig = ABTestConfigsBase[env];

      let ABTest;

      const ABTestCache = ABTestsCache[key];

      if (ABTestCache?.variationKey && !Number.isNaN(ABTestCache?.variationIndex)) {
        if (
          ABTestCache.version === ABTestConfig.version &&
          (!ABTestConfig.cacheDurationInHours || getHoursInterval(new Date(), new Date(ABTestCache?.createdAt)) < ABTestConfig.cacheDurationInHours)
        )
          ABTest = ABTestCache;
      }

      if (!ABTest) {
        const variationIndex = pickIndexByChance(ABTestConfig?.variationsWeights);
        const variation = ABTestVariations[variationIndex || 0];

        ABTest = { variationKey: variation?.key, variationIndex: variationIndex, createdAt: new Date().toISOString(), version: ABTestConfig?.version };
      }

      return {
        ...treatedABTests,
        [key]: ABTest,
      };
    } catch (err) {
      console.error(err);
      return treatedABTests;
    }
  }, {});

  localStorage.setItem("ABTests", JSON.stringify(treatedABTests));

  return treatedABTests;
};
